import { render, staticRenderFns } from "./Saque.vue?vue&type=template&id=219b9c6a&"
import script from "./Saque.vue?vue&type=script&lang=ts&"
export * from "./Saque.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports